module.exports = __webpack_public_path__ + "static/johamedsub-fdb35748d152b003e3a59c73a772aa1c.mp4";